import React,{useState,useEffect,useRef} from 'react'
import style from './Upload.module.css';
import axios from 'axios';

const Upload =()=> {
  const [phoneNumber , setPhoneNumber] = useState('');
  const [csvFile , setCsvFile] = useState(null);
  const [singleMsz , setSingleMsz] = useState('');
  const [batchMsz,setBatchMsz] = useState('');

  const fileInputRef = useRef(null);
  const base_url = process.env.REACT_APP_BASE_URL;

  const handleSingleUserSubmit = async ()=>{
    if(phoneNumber.length!== 10){
        // console.log(phoneNumber.length);
        setSingleMsz("Enter valid 10 digit number with country code!");
        return; 
    }
    try {
        const resp = await axios.post(`${base_url}/user/registerSingleUser`,{
            phoneNumber : phoneNumber
        },{
            headers:{
                "Content-Type" : "application/json"
            }
        });

        setSingleMsz(resp.data.message);
        setPhoneNumber('');
        
    } catch (error) {
        console.log("error occured : ",error.message);
        setSingleMsz(error.message);
    }
    
  }

  const handleButtonClick = (event) => {
    event.preventDefault();
    fileInputRef.current.click();
  };

  const handleFileChange = (event)=>{
    const file = event.target.files[0];
    setCsvFile(file);
  }

  const openCsvFile = () => {
    const csvUrl = 'https://daisy-audiobook-website-v2.s3.us-west-2.amazonaws.com/sample+csv+for+daisy+users+-+Sheet1.csv';
    window.open(csvUrl, '_blank');
  };

  const handleBatchUserSubmit = async ()=>{
    console.log(csvFile.type);
    if(csvFile.type !== 'text/csv'){
        setBatchMsz("Upload a CSV File Please");
        return;
    }
    try {
        const formData = new FormData();
        formData.append('file',csvFile);
        const resp = await axios.post(`${base_url}/user/registerBatchUser`,formData,{
            headers:{
                "Content-Type":"multipart/form-data"
            }
        });
        console.log(resp.data);
        setBatchMsz(resp.data.message);
        setCsvFile(null);
    } catch (error) {
        console.log("error in handleBatchUserSubmit : ",error.message);
        setBatchMsz(error.message);
    }
  }


  return (
    <div className={style.maindiv}>
        <div className={style.singleUpload}>
            <h2>Add Single User</h2>
            <p>Enter User's phone number to add him/her to the IVR library</p>

            <lable>Enter Number</lable>
            <input type='tel' value={phoneNumber} onChange={(e)=>{setPhoneNumber(e.target.value)}} />

            <button onClick={handleSingleUserSubmit}>Add User</button>
            <p className={style.msz}>{singleMsz}</p>

        </div>
        <div className={style.multipleUpload}>
            <h2>Add Multiple Users</h2>
            <p>Upload a csv file with numbers to add multiple Users (download the sample csv file to see the format) </p>

            <button onClick={openCsvFile}>View the CSV File format</button>


            <label>
                            {csvFile ? csvFile.name : 'Choose a file'}
            </label>
            <div className="flex">
                <button className="p-6  text-white dark:text-white" aria-label="Attach file" onClick={handleButtonClick}>
                    <div className="flex flex-row border-2 border-black">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9 7C9 4.23858 11.2386 2 14 2C16.7614 2 19 4.23858 19 7V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V9C5 8.44772 5.44772 8 6 8C6.55228 8 7 8.44772 7 9V15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15V7C17 5.34315 15.6569 4 14 4C12.3431 4 11 5.34315 11 7V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V9C13 8.44772 13.4477 8 14 8C14.5523 8 15 8.44772 15 9V15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15V7Z" fill="white"></path>
                        </svg>
                        <span className="text-white border-2 border-white">Attach File</span>
                    </div>
                </button>
                <input  
                ref={fileInputRef}
                type="file"
                tabIndex="-1"
                className="hidden"
                style={{ display: 'none' }} 
                onChange={handleFileChange}
                />
            </div>

            <button onClick={handleBatchUserSubmit}>Add Users</button>

            <p className={style.msz}>{batchMsz}</p>
        </div>
    </div>
  )
}

export default Upload